import type { PermissionKey } from '@kalachand/shared';
import type { ReactNode } from 'react';
import { useAuth } from './auth';

export function useHasPermission(...keys: PermissionKey[]): boolean {
  const { perms } = useAuth();
  return keys.every((k) => perms.has(k));
}

export function useHasAnyPermission(...keys: PermissionKey[]): boolean {
  const { perms } = useAuth();
  return keys.some((k) => perms.has(k));
}

/** Render children only if all listed permissions are granted. */
export function Can({
  permission,
  permissions,
  any,
  children,
  fallback = null,
}: {
  permission?: PermissionKey;
  permissions?: PermissionKey[];
  any?: boolean;
  children: ReactNode;
  fallback?: ReactNode;
}): JSX.Element {
  const keys: PermissionKey[] = permission ? [permission] : (permissions ?? []);
  const { perms } = useAuth();
  const ok = any ? keys.some((k) => perms.has(k)) : keys.every((k) => perms.has(k));
  return <>{ok ? children : fallback}</>;
}
